import React from "react";
import "../styles/Testimonials.css";
import { useLanguage } from "../contexts/LanguageContext";

const initialsOf = (name) =>
  name
    .replace(/[".]/g, "")
    .split(/\s+/)
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const Testimonials = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const t = text.testimonials;

  return (
    <section
      id="testimonials"
      className="testimonials-section"
      dir={isHeb ? "rtl" : "ltr"}
    >
      <span className="eyebrow">{t.eyebrow}</span>
      <h2 className="section-title">{t.title}</h2>
      <p className="testimonials-lede">{t.lede}</p>

      <div className="logo-strip" aria-label={t.logosLabel}>
        <span className="logo-strip-label">{t.logosLabel}</span>
        <ul className="logo-strip-list">
          {t.logos.map((logo) => (
            <li key={logo.name} className="logo-chip">
              <span className="logo-mark" aria-hidden="true">
                {logo.name
                  .split(" ")
                  .map((p) => p[0])
                  .slice(0, 2)
                  .join("")}
              </span>
              <span className="logo-name">{logo.name}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="testimonials-grid">
        {t.items.map((item, i) => (
          <figure key={i} className="testimonial-card">
            <svg
              className="quote-mark"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M9 7H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2v2a2 2 0 0 1-2 2H4v2h1a4 4 0 0 0 4-4V7zm12 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2v2a2 2 0 0 1-2 2h-1v2h1a4 4 0 0 0 4-4V7z" />
            </svg>
            <blockquote className="testimonial-quote">"{item.quote}"</blockquote>
            <figcaption className="testimonial-meta">
              <div className="testimonial-avatar" aria-hidden="true">
                {initialsOf(item.name)}
              </div>
              <div className="testimonial-who">
                <span className="testimonial-name">{item.name}</span>
                <span className="testimonial-role">{item.role}</span>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
